import { Client } from "@stomp/stompjs";
import PropTypes from "prop-types";
import { createContext, useEffect, useRef, useState } from "react";
import { socketUrl } from "../../config/baseURL";

export const NotificationContext = createContext();
const { Provider } = NotificationContext;
const unitId = localStorage?.getItem("unitId");
function NotificationProvider({ children = null }) {
  const [storeNotification, setStoreNotification] = useState({});
  const clientRef = useRef(null);
  const unitId = localStorage.getItem("unitId")
    ? localStorage.getItem("unitId")
    : 1;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (unitId && token) {
      const userClient = new Client({
        brokerURL: socketUrl,
        debug: function (str) {
          // console.log(str);
        },
      });
      clientRef.current = userClient;

      userClient.onConnect = function (frame) {
        // console.log("User connected====>>>>> " + frame);

        userClient.subscribe(
          `/user/exchange_${unitId ? unitId : 1}/queue/notifications`,
          // `/user/diagram/queue/notifications`,
          (message) => {
            // console.log("Notification received====>>>: ", message.body);
            try {
              const notification = JSON.parse(message.body);
              setStoreNotification(notification);
              console.log("Notification content====>>> ", notification);
            } catch (e) {
              // console.error("Failed to parse notification message:", e);
            }
          }
        );
      };

      userClient.onWebSocketError = (error) => {
        console.error("Error with websocket", error);
      };

      userClient.activate();

      return () => {
        userClient.deactivate();
      };
    }
  }, [unitId && token]);
  const stopSocket = () => {
    if (clientRef.current && clientRef.current.connected) {
      clientRef.current.deactivate();
      console.log("Socket disconnected manually.");
    }
  };

  const value = [storeNotification, stopSocket];

  return <Provider value={value}>{children}</Provider>;
}

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NotificationProvider;
